import {gql} from '@apollo/client';

/**
 * Anonymous pilot-access mutations — the visitor has no Planapus account
 * yet. Backed by `pilot-access.graphql` / `pilot-access-resolvers.ts`.
 */

/** Gate check: is this invite code valid? Returns the bound identity for prefill. */
export const VALIDATE_PILOT_INVITE = gql`
  mutation ValidatePilotInvite($code: ID!) {
    validatePilotInvite(code: $code) {
      valid
      email
      name
      audience
    }
  }
`;

/**
 * "Lost my link" — resend the invite to the email it's bound to. The
 * backend is anti-enumeration: `sent` is always true, the email only
 * actually goes out if an active invite exists for that address.
 */
export const REQUEST_PILOT_INVITE_BY_EMAIL = gql`
  mutation RequestPilotInviteByEmail($email: String!) {
    requestPilotInviteByEmail(email: $email) {
      sent
    }
  }
`;
